import './Tema.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Tema = ({ btn, tema, setTema, storage }) => {

  // Troca entre temas
  const toggleTheme = () => {
      const newTheme = tema === 'light' ? 'dark' : 'light';
      storage.remover("theme");
      storage.adicionar("theme", { theme:newTheme });
      setTema(newTheme);
  };
  
  //Atualizar
  useEffect(() => {
    if(tema){
      document.body.className = tema;
    }
  },[tema])

  if(!btn) return;
  
  return (
    <Link to={btn.to} onClick={() => { toggleTheme(); btn?.onClick(); }} className={btn.className}>
        <i class="bi bi-circle-half"></i> {btn.text || `Mudar para ${tema === 'dark' ? 'claro' : 'escuro'}`}
    </Link>
  );
};

export default Tema;